module.exports = __webpack_public_path__ + "img/9788993094350.ae90ed1f.jpg";